import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";

const articles = [
  {
    title: "The Future of Security Patrol Management",
    description: "How AI and real-time GPS tracking are transforming the security industry and increasing guard accountability.",
    date: "March 15, 2026",
    category: "Industry News"
  },
  {
    title: "5 Ways to Prevent Guard Fraud",
    description: "Learn how biometric face verification and geofencing eliminate the possibility of 'ghost patrols' at your sites.",
    date: "March 10, 2026",
    category: "Best Practices"
  },
  {
    title: "Optimizing Your Security Operations",
    description: "Discover how automated scheduling and AI incident analysis can reduce administrative overhead and improve site safety.",
    date: "March 5, 2026",
    category: "Case Study"
  }
];

const BlogSection = () => {
  return (
    <section id="resources" className="py-24">
      <div className="mx-auto max-w-7xl px-6">
        <p className="text-sm font-semibold tracking-widest text-primary text-center">Resources & Insights</p>
        <h2 className="mt-2 text-3xl font-bold md:text-5xl text-center">SECUREFLEX KNOWLEDGE CENTER</h2>
        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {articles.map((article, i) => (
            <Card key={i} className="bg-card border-border hover:border-primary/50 transition-colors animate-fade-in" style={{ animationDelay: `${i * 0.1}s`, animationFillMode: "backwards" }}>
              <CardHeader>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-xs font-bold text-primary tracking-widest uppercase">{article.category}</span>
                  <span className="text-xs text-muted-foreground">{article.date}</span>
                </div>
                <CardTitle className="text-xl leading-tight hover:text-primary transition-colors cursor-pointer" onClick={() => toast.info("Full article coming soon!")}>
                  {article.title}
                </CardTitle>
                <CardDescription className="pt-2">
                  {article.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <Button variant="ghost" className="p-0 h-auto gap-2 text-sm text-primary hover:text-primary/80 group" onClick={() => toast.info("Full article coming soon!")}>
                  Read Article <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
        <div className="mt-12 text-center">
          <Button variant="outline" className="rounded-full gap-2" onClick={() => toast.info("Resource library coming soon!")}>
            View All Resources <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
